import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useDashboardContext} from '../DashboardContext';
import GridTable from '../../../../common/components/core/GridTable';
import Spinner from '../../../../common/components/ui/Spinner';
import styles from './Grid.module.scss';

const Grid = () => {
  const {table, invoicesCount, loading} = useDashboardContext();

  return (
    <div className={styles.gridContainer}>
      <div className={styles.customTableHead}>
        <div>
          <FormattedMessage
            id={'dashboard-grid-invoicesList'}
            defaultMessage={'Invoice orders'}
          />
        </div>
        {!loading && (invoicesCount > 6) && (
          <div>
            <FormattedMessage
              id={'dashboard-grid-invoicesList-count'}
              defaultMessage={'6 of {invoiceOrdersCount}'}
              values={{count: invoicesCount}}
            />
          </div>
        )}
      </div>
      {loading
        ? <Spinner/>
        : (
          <GridTable
            table={table}
            emptyLabel={(
              <div className={styles.empty}>
                <FormattedMessage
                  id={'dashboard-grid-invoicesList-empty'}
                  defaultMessage={'There are no open invoices to display'}
                />
              </div>
            )}
          />
        )}
    </div>
  );
};

export default Grid;
